import { CommonError } from './CommonError';
export default class ValidationError extends CommonError {
    validationErrors = [];
    code = '';
    constructor(message, errors, code) {
        super(message);
        this.message =
            message +
                ' => ' +
                errors
                    .map((error) => error.key + ': ' + error.message)
                    .join(', ');
        this.validationErrors = errors;
        this.code = code;
        Object.setPrototypeOf(this, ValidationError.prototype);
        this.name = this.getCode();
    }
    getValidationErrors() {
        return this.validationErrors;
    }
}
//# sourceMappingURL=ValidationError.js.map